import React, { useState, useMemo } from 'react';
import { X } from 'lucide-react';

interface EmojiCategory {
  id: string;
  name: string;
  icon: string;
  emojis: { emoji: string; name: string; animation?: string }[];
}

const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'smile',
    name: '笑脸',
    icon: '😊',
    emojis: [
      { emoji: '😀', name: '大笑', animation: 'bounce' },
      { emoji: '😃', name: '开心笑', animation: 'bounce' },
      { emoji: '😄', name: '眯眼笑', animation: 'bounce' },
      { emoji: '😁', name: '露齿笑', animation: 'pulse' },
      { emoji: '😆', name: '开心', animation: 'shake' },
      { emoji: '😅', name: '汗', animation: 'sweat' },
      { emoji: '🤣', name: '笑翻', animation: 'roll' },
      { emoji: '😂', name: '笑哭', animation: 'shake' },
      { emoji: '🙂', name: '微笑', animation: 'bounce' },
      { emoji: '🙃', name: '倒笑', animation: 'flip' },
      { emoji: '😉', name: '眨眼', animation: 'wink' },
      { emoji: '😊', name: '害羞笑', animation: 'peek' },
      { emoji: '😇', name: '天使', animation: 'halo' },
      { emoji: '🥰', name: '喜欢', animation: 'heartbeat' },
      { emoji: '😍', name: '花痴', animation: 'sparkle' },
      { emoji: '🤩', name: '星星眼', animation: 'twinkle' },
      { emoji: '😘', name: '飞吻', animation: 'blow' },
      { emoji: '😗', name: '亲亲', animation: 'peek' },
      { emoji: '😚', name: '羞涩亲亲', animation: 'peek' },
      { emoji: '😋', name: '馋', animation: 'yum' },
      { emoji: '😛', name: '吐舌', animation: 'wiggle' },
      { emoji: '😜', name: '眨眼吐舌', animation: 'wink' },
      { emoji: '🤪', name: '疯狂', animation: 'wiggle' },
      { emoji: '😝', name: '调皮', animation: 'wiggle' },
      { emoji: '🤑', name: '发财', animation: 'sparkle' },
      { emoji: '🤗', name: '拥抱', animation: 'hug' },
      { emoji: '🤭', name: '捂嘴笑', animation: 'peek' },
      { emoji: '🤫', name: '嘘', animation: 'stop' },
      { emoji: '🤔', name: '思考', animation: 'tilt' },
      { emoji: '🤐', name: '闭嘴', animation: 'stop' },
      { emoji: '🤨', name: '挑眉', animation: 'tilt' },
      { emoji: '😐', name: '面无表情', animation: 'pulse' },
      { emoji: '😑', name: '无语', animation: 'stop' },
      { emoji: '😶', name: '沉默', animation: 'stop' },
      { emoji: '😏', name: '得意', animation: 'wiggle' },
      { emoji: '😒', name: '不爽', animation: 'frown' },
      { emoji: '🙄', name: '翻白眼', animation: 'roll' },
      { emoji: '😬', name: '尴尬', animation: 'sweat' },
      { emoji: '🤥', name: '说谎', animation: 'shake' },
      { emoji: '😌', name: '释然', animation: 'relax' },
      { emoji: '😔', name: '遗憾', animation: 'frown' },
      { emoji: '😪', name: '困倦', animation: 'sleep' },
      { emoji: '🤤', name: '流口水', animation: 'yum' },
      { emoji: '😴', name: '睡觉', animation: 'sleep' },
      { emoji: '😷', name: '戴口罩', animation: 'sick' },
      { emoji: '🤒', name: '发烧', animation: 'sick' },
      { emoji: '🤕', name: '受伤', animation: 'hurt' },
      { emoji: '🤢', name: '恶心', animation: 'sick' },
      { emoji: '🤮', name: '呕吐', animation: 'sick' },
      { emoji: '🥵', name: '热', animation: 'hot' },
      { emoji: '🥶', name: '冷', animation: 'cold' },
      { emoji: '🥴', name: '醉', animation: 'drunk' },
    ]
  },
  {
    id: 'emotion',
    name: '情绪',
    icon: '😎',
    emojis: [
      { emoji: '😎', name: '酷', animation: 'sunglasses' },
      { emoji: '🤓', name: '书呆子', animation: 'glasses' },
      { emoji: '🧐', name: '单片眼镜', animation: 'monocle' },
      { emoji: '😕', name: '困惑', animation: 'tilt' },
      { emoji: '😟', name: '担心', animation: 'worry' },
      { emoji: '🙁', name: '不开心', animation: 'frown' },
      { emoji: '☹️', name: '难过', animation: 'frown' },
      { emoji: '😮', name: '惊讶', animation: 'pop' },
      { emoji: '😲', name: '震惊', animation: 'shock' },
      { emoji: '😯', name: '沉默惊讶', animation: 'pop' },
      { emoji: '🥺', name: '恳求', animation: 'crybaby' },
      { emoji: '😨', name: '害怕', animation: 'tremble' },
      { emoji: '😰', name: '焦虑', animation: 'sweat' },
      { emoji: '😥', name: '失望', animation: 'cry' },
      { emoji: '😢', name: '哭泣', animation: 'cry' },
      { emoji: '😭', name: '大哭', animation: 'bawling' },
      { emoji: '😱', name: '尖叫', animation: 'scream' },
      { emoji: '😵', name: '眩晕', animation: 'spin' },
      { emoji: '😵‍💫', name: '头晕', animation: 'spin' },
      { emoji: '🤯', name: '爆炸', animation: 'explode' },
      { emoji: '🥳', name: '庆祝', animation: 'party' },
      { emoji: '🥸', name: '伪装', animation: 'wiggle' },
      { emoji: '😕', name: '困惑', animation: 'tilt' },
      { emoji: '😟', name: '担心', animation: 'worry' },
      { emoji: '🙁', name: '不开心', animation: 'frown' },
      { emoji: '☹️', name: '难过', animation: 'frown' },
      { emoji: '😣', name: '坚持', animation: 'worry' },
      { emoji: '😖', name: '困扰', animation: 'worry' },
      { emoji: '😫', name: '疲惫', animation: 'tired' },
      { emoji: '😩', name: '累', animation: 'tired' },
      { emoji: '🥱', name: '打哈欠', animation: 'sleep' },
      { emoji: '😤', name: '生气', animation: 'angry' },
      { emoji: '😡', name: '愤怒', animation: 'angry' },
      { emoji: '😠', name: '不满', animation: 'angry' },
      { emoji: '🤬', name: '骂人', animation: 'angry' },
      { emoji: '😈', name: '小恶魔', animation: 'wiggle' },
      { emoji: '👿', name: '恶魔', animation: 'wiggle' },
      { emoji: '💀', name: '骷髅', animation: 'shake' },
      { emoji: '☠️', name: '骷髅头', animation: 'shake' },
      { emoji: '💀', name: '骷髅', animation: 'shake' },
      { emoji: '☠️', name: '危险', animation: 'shake' },
      { emoji: '💔', name: '心碎', animation: 'break' },
      { emoji: '😈', name: '淘气', animation: 'wiggle' },
      { emoji: '👹', name: '妖怪', animation: 'wiggle' },
      { emoji: '👺', name: '天狗', animation: 'wiggle' },
      { emoji: '🤡', name: '小丑', animation: 'wiggle' },
      { emoji: '👻', name: '幽灵', animation: 'float' },
      { emoji: '🎭', name: '面具', animation: 'flip' },
      { emoji: '🃏', name: '扑克牌', animation: 'flip' },
      { emoji: '🗿', name: '石像', animation: 'stone' },
      { emoji: '🤖', name: '机器人', animation: 'robot' },
      { emoji: '👽', name: '外星人', animation: 'wiggle' },
      { emoji: '👾', name: '怪物', animation: 'wiggle' },
      { emoji: '🤗', name: '拥抱', animation: 'hug' },
      { emoji: '🤝', name: '握手', animation: 'shakehand' },
    ]
  },
  {
    id: 'hands',
    name: '手势',
    icon: '👍',
    emojis: [
      { emoji: '👍', name: '点赞', animation: 'thumbsup' },
      { emoji: '👎', name: '差评', animation: 'thumbsdown' },
      { emoji: '👏', name: '鼓掌', animation: 'clap' },
      { emoji: '🙌', name: '举手', animation: 'raise' },
      { emoji: '👋', name: '挥手', animation: 'wave' },
      { emoji: '✋', name: '停止', animation: 'stop' },
      { emoji: '🤚', name: '手掌', animation: 'stop' },
      { emoji: '🖐️', name: '五指', animation: 'stop' },
      { emoji: '🖖', name: '瓦肯', animation: 'vulcan' },
      { emoji: '🤝', name: '握手', animation: 'shakehand' },
      { emoji: '💪', name: '肌肉', animation: 'flex' },
      { emoji: '✌️', name: '胜利', animation: 'victory' },
      { emoji: '🤘', name: '摇滚', animation: 'rock' },
      { emoji: '👌', name: '完美', animation: 'ok' },
      { emoji: '🙏', name: '祈祷', animation: 'pray' },
      { emoji: '🤟', name: '爱你', animation: 'ily' },
      { emoji: '🤞', name: '幸运', animation: 'cross' },
      { emoji: '👊', name: '加油', animation: 'punch' },
      { emoji: '💅', name: '美甲', animation: 'nail' },
      { emoji: '🤌', name: '捏手指', animation: 'pinch' },
      { emoji: '🤏', name: '一点点', animation: 'small' },
      { emoji: '✍️', name: '写字', animation: 'write' },
      { emoji: '🫰', name: '捏钱', animation: 'money' },
      { emoji: '🫱', name: '手掌左', animation: 'hand' },
      { emoji: '🫲', name: '手掌右', animation: 'hand' },
      { emoji: '🫳', name: '手掌下', animation: 'hand' },
      { emoji: '🫴', name: '手掌上', animation: 'hand' },
      { emoji: '🤚🏻', name: '手掌白', animation: 'stop' },
      { emoji: '🤚🏼', name: '手掌浅', animation: 'stop' },
      { emoji: '🤚🏽', name: '手掌中', animation: 'stop' },
      { emoji: '🤚🏾', name: '手掌深', animation: 'stop' },
      { emoji: '🤚🏿', name: '手掌黑', animation: 'stop' },
      { emoji: '👍🏻', name: '点赞白', animation: 'thumbsup' },
      { emoji: '👍🏼', name: '点赞浅', animation: 'thumbsup' },
      { emoji: '👍🏽', name: '点赞中', animation: 'thumbsup' },
      { emoji: '👍🏾', name: '点赞深', animation: 'thumbsup' },
      { emoji: '👍🏿', name: '点赞黑', animation: 'thumbsup' },
      { emoji: '👋🏻', name: '挥手白', animation: 'wave' },
      { emoji: '👋🏼', name: '挥手浅', animation: 'wave' },
      { emoji: '👋🏽', name: '挥手中', animation: 'wave' },
      { emoji: '👋🏾', name: '挥手深', animation: 'wave' },
      { emoji: '👋🏿', name: '挥手黑', animation: 'wave' },
      { emoji: '✊', name: '握紧', animation: 'punch' },
      { emoji: '✊🏻', name: '握紧白', animation: 'punch' },
      { emoji: '✊🏼', name: '握紧浅', animation: 'punch' },
      { emoji: '✊🏽', name: '握紧中', animation: 'punch' },
      { emoji: '✊🏾', name: '握紧深', animation: 'punch' },
      { emoji: '✊🏿', name: '握紧黑', animation: 'punch' },
      { emoji: '✌️🏻', name: '胜利白', animation: 'victory' },
      { emoji: '✌️🏼', name: '胜利浅', animation: 'victory' },
      { emoji: '✌️🏽', name: '胜利中', animation: 'victory' },
      { emoji: '✌️🏾', name: '胜利深', animation: 'victory' },
      { emoji: '✌️🏿', name: '胜利黑', animation: 'victory' },
      { emoji: '🤞🏻', name: '幸运白', animation: 'cross' },
      { emoji: '🤞🏼', name: '幸运浅', animation: 'cross' },
      { emoji: '🤞🏽', name: '幸运中', animation: 'cross' },
      { emoji: '🤞🏾', name: '幸运深', animation: 'cross' },
      { emoji: '🤞🏿', name: '幸运黑', animation: 'cross' },
      { emoji: '🤟🏻', name: '爱你白', animation: 'ily' },
      { emoji: '🤟🏼', name: '爱你浅', animation: 'ily' },
      { emoji: '🤟🏽', name: '爱你中', animation: 'ily' },
      { emoji: '🤟🏾', name: '爱你深', animation: 'ily' },
      { emoji: '🤟🏿', name: '爱你黑', animation: 'ily' },
      { emoji: '🤝🏻', name: '握手白', animation: 'shakehand' },
      { emoji: '🤝🏼', name: '握手浅', animation: 'shakehand' },
      { emoji: '🤝🏽', name: '握手中', animation: 'shakehand' },
      { emoji: '🤝🏾', name: '握手深', animation: 'shakehand' },
      { emoji: '🤝🏿', name: '握手黑', animation: 'shakehand' },
      { emoji: '🙏🏻', name: '祈祷白', animation: 'pray' },
      { emoji: '🙏🏼', name: '祈祷浅', animation: 'pray' },
      { emoji: '🙏🏽', name: '祈祷中', animation: 'pray' },
      { emoji: '🙏🏾', name: '祈祷深', animation: 'pray' },
      { emoji: '🙏🏿', name: '祈祷黑', animation: 'pray' },
      { emoji: '👏🏻', name: '鼓掌白', animation: 'clap' },
      { emoji: '👏🏼', name: '鼓掌浅', animation: 'clap' },
      { emoji: '👏🏽', name: '鼓掌中', animation: 'clap' },
      { emoji: '👏🏾', name: '鼓掌深', animation: 'clap' },
      { emoji: '👏🏿', name: '鼓掌黑', animation: 'clap' },
      { emoji: '🖖🏻', name: '瓦肯白', animation: 'vulcan' },
      { emoji: '🖖🏼', name: '瓦肯浅', animation: 'vulcan' },
      { emoji: '🖖🏽', name: '瓦肯中', animation: 'vulcan' },
      { emoji: '🖖🏾', name: '瓦肯深', animation: 'vulcan' },
      { emoji: '🖖🏿', name: '瓦肯黑', animation: 'vulcan' },
      { emoji: '💪🏻', name: '肌肉白', animation: 'flex' },
      { emoji: '💪🏼', name: '肌肉浅', animation: 'flex' },
      { emoji: '💪🏽', name: '肌肉中', animation: 'flex' },
      { emoji: '💪🏾', name: '肌肉深', animation: 'flex' },
      { emoji: '💪🏿', name: '肌肉黑', animation: 'flex' },
    ]
  },
  {
    id: 'animals',
    name: '动物',
    icon: '🐵',
    emojis: [
      { emoji: '🐵', name: '猴子', animation: 'monkey' },
      { emoji: '🐒', name: '猴脸', animation: 'monkey' },
      { emoji: '🦍', name: '大猩猩', animation: 'monkey' },
      { emoji: '🦧', name: '猩猩', animation: 'monkey' },
      { emoji: '🐕', name: '狗', animation: 'dog' },
      { emoji: '🐕', name: '小狗', animation: 'dog' },
      { emoji: '🦮', name: '导盲犬', animation: 'dog' },
      { emoji: '🐩', name: '贵宾犬', animation: 'dog' },
      { emoji: '🐕‍🦺', name: '服务犬', animation: 'dog' },
      { emoji: '🐺', name: '狼', animation: 'wolf' },
      { emoji: '🦊', name: '狐狸', animation: 'fox' },
      { emoji: '🦝', name: '浣熊', animation: 'fox' },
      { emoji: '🐱', name: '猫', animation: 'cat' },
      { emoji: '🐈', name: '猫咪', animation: 'cat' },
      { emoji: '🐈‍⬛', name: '黑猫', animation: 'cat' },
      { emoji: '🦁', name: '狮子', animation: 'lion' },
      { emoji: '🐯', name: '老虎', animation: 'tiger' },
      { emoji: '🐅', name: '老虎脸', animation: 'tiger' },
      { emoji: '🐆', name: '豹子', animation: 'tiger' },
      { emoji: '🐴', name: '马', animation: 'horse' },
      { emoji: '🐎', name: '赛马', animation: 'horse' },
      { emoji: '🦄', name: '独角兽', animation: 'unicorn' },
      { emoji: '🦓', name: '斑马', animation: 'zebra' },
      { emoji: '🦒', name: '长颈鹿', animation: 'giraffe' },
      { emoji: '🐮', name: '牛', animation: 'cow' },
      { emoji: '🐂', name: '公牛', animation: 'cow' },
      { emoji: '🐃', name: '水牛', animation: 'cow' },
      { emoji: '🐄', name: '奶牛', animation: 'cow' },
      { emoji: '🐷', name: '猪', animation: 'pig' },
      { emoji: '🐖', name: '小猪', animation: 'pig' },
      { emoji: '🐗', name: '野猪', animation: 'pig' },
      { emoji: '🐽', name: '猪鼻子', animation: 'pig' },
      { emoji: '🐑', name: '绵羊', animation: 'sheep' },
      { emoji: '🐏', name: '公羊', animation: 'sheep' },
      { emoji: '🐐', name: '山羊', animation: 'goat' },
      { emoji: '🦌', name: '鹿', animation: 'deer' },
      { emoji: '🦘', name: '袋鼠', animation: 'jump' },
      { emoji: '🦡', name: '豪猪', animation: 'shake' },
      { emoji: '🐰', name: '兔子', animation: 'bunny' },
      { emoji: '🐇', name: '兔子脸', animation: 'bunny' },
      { emoji: '🐻', name: '熊', animation: 'bear' },
      { emoji: '🐻‍❄️', name: '北极熊', animation: 'bear' },
      { emoji: '🐼', name: '熊猫', animation: 'panda' },
      { emoji: '🐨', name: '考拉', animation: 'koala' },
      { emoji: '🦥', name: '树懒', animation: 'slow' },
      { emoji: '🦦', name: '水獭', animation: 'swim' },
      { emoji: '🦔', name: '刺猬', animation: 'shake' },
      { emoji: '🐘', name: '大象', animation: 'elephant' },
      { emoji: '🦏', name: '犀牛', animation: 'rhino' },
      { emoji: '🦛', name: '河马', animation: 'hippo' },
      { emoji: '🐪', name: '骆驼', animation: 'camel' },
      { emoji: '🐫', name: '双峰驼', animation: 'camel' },
      { emoji: '🦙', name: '羊驼', animation: 'llama' },
      { emoji: '🦒', name: '长颈鹿', animation: 'giraffe' },
      { emoji: '🐔', name: '鸡', animation: 'chicken' },
      { emoji: '🐓', name: '公鸡', animation: 'chicken' },
      { emoji: '🐣', name: '小鸡', animation: 'chicken' },
      { emoji: '🐤', name: '小鸡仔', animation: 'chicken' },
      { emoji: '🐥', name: '雏鸡', animation: 'chicken' },
      { emoji: '🐦', name: '鸟', animation: 'bird' },
      { emoji: '🐧', name: '企鹅', animation: 'penguin' },
      { emoji: '🕊️', name: '鸽子', animation: 'bird' },
      { emoji: '🦅', name: '鹰', animation: 'eagle' },
      { emoji: '🦆', name: '鸭子', animation: 'duck' },
      { emoji: '🦢', name: '天鹅', animation: 'swan' },
      { emoji: '🦜', name: '鹦鹉', animation: 'parrot' },
      { emoji: '🦉', name: '猫头鹰', animation: 'owl' },
      { emoji: '🦩', name: '火烈鸟', animation: 'bird' },
      { emoji: '🦚', name: '孔雀', animation: 'bird' },
      { emoji: '🦃', name: '火鸡', animation: 'chicken' },
      { emoji: '🕊️', name: '和平鸽', animation: 'bird' },
      { emoji: '🐝', name: '蜜蜂', animation: 'bee' },
      { emoji: '🐞', name: '瓢虫', animation: 'bug' },
      { emoji: '🦋', name: '蝴蝶', animation: 'butterfly' },
      { emoji: '🐌', name: '蜗牛', animation: 'snail' },
      { emoji: '🐛', name: '毛毛虫', animation: 'bug' },
      { emoji: '🦗', name: '蟋蟀', animation: 'bug' },
      { emoji: '🐜', name: '蚂蚁', animation: 'bug' },
      { emoji: '🪲', name: '甲虫', animation: 'bug' },
      { emoji: '🦟', name: '蚊子', animation: 'bug' },
      { emoji: '🪳', name: '蟑螂', animation: 'bug' },
      { emoji: '🐢', name: '乌龟', animation: 'turtle' },
      { emoji: '🐍', name: '蛇', animation: 'snake' },
      { emoji: '🦎', name: '蜥蜴', animation: 'lizard' },
      { emoji: '🦖', name: '恐龙', animation: 'dino' },
      { emoji: '🦕', name: '长颈龙', animation: 'dino' },
      { emoji: '🐊', name: '鳄鱼', animation: 'croc' },
      { emoji: '🐢', name: '海龟', animation: 'turtle' },
      { emoji: '🦑', name: '乌贼', animation: 'squid' },
      { emoji: '🐙', name: '章鱼', animation: 'octopus' },
      { emoji: '🦐', name: '虾', animation: 'bounce' },
      { emoji: '🦞', name: '龙虾', animation: 'bounce' },
      { emoji: '🦀', name: '螃蟹', animation: 'crab' },
      { emoji: '🐠', name: '热带鱼', animation: 'fish' },
      { emoji: '🐟', name: '鱼', animation: 'fish' },
      { emoji: '🐡', name: '河豚', animation: 'fish' },
      { emoji: '🐬', name: '海豚', animation: 'dolphin' },
      { emoji: '🦈', name: '鲨鱼', animation: 'fish' },
      { emoji: '🐳', name: '喷水鲸', animation: 'whale' },
      { emoji: '🐋', name: '鲸鱼', animation: 'whale' },
      { emoji: '🦭', name: '海豹', animation: 'swim' },
      { emoji: '🐬', name: '海豚', animation: 'dolphin' },
      { emoji: '🦑', name: '鱿鱼', animation: 'squid' },
      { emoji: '🪸', name: '珊瑚', animation: 'wave' },
      { emoji: '🐚', name: '贝壳', animation: 'bounce' },
      { emoji: '🦪', name: '生蚝', animation: 'bounce' },
      { emoji: '🦩', name: '粉红鸟', animation: 'bird' },
    ]
  },
  {
    id: 'food',
    name: '食物',
    icon: '🍎',
    emojis: [
      { emoji: '🍎', name: '苹果', animation: 'bounce' },
      { emoji: '🍊', name: '橙子', animation: 'bounce' },
      { emoji: '🍋', name: '柠檬', animation: 'bounce' },
      { emoji: '🍌', name: '香蕉', animation: 'bounce' },
      { emoji: '🍉', name: '西瓜', animation: 'slice' },
      { emoji: '🍇', name: '葡萄', animation: 'bounce' },
      { emoji: '🍓', name: '草莓', animation: 'juicy' },
      { emoji: '🍑', name: '桃子', animation: 'bounce' },
      { emoji: '🍒', name: '樱桃', animation: 'bounce' },
      { emoji: '🥝', name: '猕猴桃', animation: 'bounce' },
      { emoji: '🍅', name: '番茄', animation: 'bounce' },
      { emoji: '🥑', name: '牛油果', animation: 'bounce' },
      { emoji: '🌽', name: '玉米', animation: 'bounce' },
      { emoji: '🥕', name: '胡萝卜', animation: 'bounce' },
      { emoji: '🥦', name: '西兰花', animation: 'bounce' },
      { emoji: '🍆', name: '茄子', animation: 'bounce' },
      { emoji: '🥔', name: '土豆', animation: 'bounce' },
      { emoji: '🧅', name: '洋葱', animation: 'bounce' },
      { emoji: '🥬', name: '青菜', animation: 'bounce' },
      { emoji: '🌶️', name: '辣椒', animation: 'hot' },
      { emoji: '🍔', name: '汉堡', animation: 'bounce' },
      { emoji: '🍕', name: '披萨', animation: 'spin' },
      { emoji: '🌭', name: '热狗', animation: 'bounce' },
      { emoji: '🍿', name: '爆米花', animation: 'pop' },
      { emoji: '🍩', name: '甜甜圈', animation: 'roll' },
      { emoji: '🎂', name: '蛋糕', animation: 'sparkle' },
      { emoji: '🍰', name: '蛋糕片', animation: 'bounce' },
      { emoji: '🍪', name: '饼干', animation: 'crunch' },
      { emoji: '🍫', name: '巧克力', animation: 'melt' },
      { emoji: '🍬', name: '糖果', animation: 'bounce' },
      { emoji: '🍭', name: '棒棒糖', animation: 'spin' },
      { emoji: '🍮', name: '布丁', animation: 'bounce' },
      { emoji: '🍦', name: '冰淇淋', animation: 'melt' },
      { emoji: '🍧', name: '刨冰', animation: 'snow' },
      { emoji: '🍨', name: '雪糕', animation: 'melt' },
      { emoji: '🥧', name: '派', animation: 'bounce' },
      { emoji: '🥞', name: '煎饼', animation: 'bounce' },
      { emoji: '🍝', name: '面条', animation: 'swirl' },
      { emoji: '🍛', name: '咖喱饭', animation: 'steam' },
      { emoji: '🍲', name: '汤', animation: 'steam' },
      { emoji: '🥘', name: '砂锅', animation: 'steam' },
      { emoji: '🍢', name: '串串', animation: 'bounce' },
      { emoji: '🍣', name: '寿司', animation: 'bounce' },
      { emoji: '🍤', name: '虾', animation: 'bounce' },
      { emoji: '🦪', name: '生蚝', animation: 'bounce' },
      { emoji: '🍱', name: '便当', animation: 'bounce' },
      { emoji: '🍚', name: '米饭', animation: 'bounce' },
      { emoji: '🍙', name: '饭团', animation: 'bounce' },
      { emoji: '🍘', name: '米饼', animation: 'crunch' },
      { emoji: '🍥', name: '鱼板', animation: 'bounce' },
      { emoji: '🥮', name: '月饼', animation: 'bounce' },
      { emoji: '🥟', name: '饺子', animation: 'bounce' },
      { emoji: '🥠', name: '粽子', animation: 'bounce' },
      { emoji: '🥡', name: '外卖', animation: 'bounce' },
      { emoji: '🍱', name: '日式便当', animation: 'bounce' },
      { emoji: '🍲', name: '中式汤', animation: 'steam' },
      { emoji: '🍳', name: '煎蛋', animation: 'bounce' },
      { emoji: '🥚', name: '鸡蛋', animation: 'bounce' },
      { emoji: '🥓', name: '培根', animation: 'bounce' },
      { emoji: '🥩', name: '牛排', animation: 'bounce' },
      { emoji: '🍗', name: '鸡腿', animation: 'bounce' },
      { emoji: '🍖', name: '排骨', animation: 'bounce' },
      { emoji: '🦴', name: '骨头', animation: 'bounce' },
      { emoji: '🐟', name: '鱼', animation: 'fish' },
      { emoji: '🐠', name: '热带鱼', animation: 'fish' },
      { emoji: '🐡', name: '河豚', animation: 'fish' },
      { emoji: '🦐', name: '虾', animation: 'bounce' },
      { emoji: '🦑', name: '乌贼', animation: 'squid' },
      { emoji: '🦞', name: '龙虾', animation: 'bounce' },
      { emoji: '🦀', name: '螃蟹', animation: 'crab' },
      { emoji: '🐙', name: '章鱼', animation: 'octopus' },
    ]
  },
  {
    id: 'drinks',
    name: '饮料',
    icon: '☕',
    emojis: [
      { emoji: '☕', name: '咖啡', animation: 'steam' },
      { emoji: '🍵', name: '茶', animation: 'steam' },
      { emoji: '🫖', name: '茶壶', animation: 'steam' },
      { emoji: '🍶', name: '清酒', animation: 'bubble' },
      { emoji: '🍷', name: '红酒', animation: 'swirl' },
      { emoji: '🍸', name: '鸡尾酒', animation: 'swirl' },
      { emoji: '🍹', name: '热带饮品', animation: 'swirl' },
      { emoji: '🍺', name: '啤酒', animation: 'bubble' },
      { emoji: '🍻', name: '干杯', animation: 'bubble' },
      { emoji: '🥂', name: '香槟', animation: 'bubble' },
      { emoji: '🥃', name: '威士忌', animation: 'swirl' },
      { emoji: '🧉', name: '马黛茶', animation: 'steam' },
      { emoji: '🥤', name: '汽水', animation: 'bubble' },
      { emoji: '🧃', name: '果汁', animation: 'bubble' },
      { emoji: '🥛', name: '牛奶', animation: 'bounce' },
      { emoji: '🍼', name: '奶瓶', animation: 'bounce' },
      { emoji: '🧊', name: '冰块', animation: 'cold' },
      { emoji: '🍾', name: '香槟瓶', animation: 'bubble' },
    ]
  },
  {
    id: 'symbols',
    name: '符号',
    icon: '❤️',
    emojis: [
      { emoji: '❤️', name: '红心', animation: 'heartbeat' },
      { emoji: '🧡', name: '橙心', animation: 'heartbeat' },
      { emoji: '💛', name: '黄心', animation: 'heartbeat' },
      { emoji: '💚', name: '绿心', animation: 'heartbeat' },
      { emoji: '💙', name: '蓝心', animation: 'heartbeat' },
      { emoji: '💜', name: '紫心', animation: 'heartbeat' },
      { emoji: '🖤', name: '黑心', animation: 'heartbeat' },
      { emoji: '🤍', name: '白心', animation: 'heartbeat' },
      { emoji: '🤎', name: '棕心', animation: 'heartbeat' },
      { emoji: '💔', name: '心碎', animation: 'break' },
      { emoji: '❣️', name: '心叹', animation: 'heartbeat' },
      { emoji: '💕', name: '两颗心', animation: 'heartfloat' },
      { emoji: '💞', name: '旋转心', animation: 'heartfloat' },
      { emoji: '💓', name: '跳动心', animation: 'heartbeat' },
      { emoji: '💗', name: '成长心', animation: 'heartbeat' },
      { emoji: '💖', name: '闪亮心', animation: 'sparkle' },
      { emoji: '💘', name: '丘比特', animation: 'cupid' },
      { emoji: '💝', name: '礼物心', animation: 'gift' },
      { emoji: '💟', name: '心框', animation: 'heartbeat' },
      { emoji: '💯', name: '满分', animation: 'perfect' },
      { emoji: '✨', name: '闪烁', animation: 'sparkle' },
      { emoji: '🔥', name: '火焰', animation: 'fire' },
      { emoji: '💫', name: '星星', animation: 'twinkle' },
      { emoji: '💥', name: '爆炸', animation: 'boom' },
      { emoji: '🎉', name: '庆祝', animation: 'party' },
      { emoji: '🎊', name: '彩带', animation: 'confetti' },
      { emoji: '🎁', name: '礼物', animation: 'gift' },
      { emoji: '🎈', name: '气球', animation: 'float' },
      { emoji: '🎀', name: '蝴蝶结', animation: 'bounce' },
      { emoji: '🏆', name: '奖杯', animation: 'trophy' },
      { emoji: '🎯', name: '靶子', animation: 'target' },
      { emoji: '🎮', name: '游戏', animation: 'game' },
      { emoji: '🎲', name: '骰子', animation: 'roll' },
      { emoji: '🃏', name: '扑克牌', animation: 'flip' },
      { emoji: '🎴', name: '花牌', animation: 'flip' },
      { emoji: '🎵', name: '音符', animation: 'music' },
      { emoji: '🎶', name: '音符组', animation: 'music' },
      { emoji: '🎹', name: '钢琴', animation: 'piano' },
      { emoji: '🎸', name: '吉他', animation: 'guitar' },
      { emoji: '🎺', name: '小号', animation: 'music' },
      { emoji: '🎻', name: '小提琴', animation: 'music' },
      { emoji: '🥁', name: '鼓', animation: 'drum' },
      { emoji: '🎤', name: '麦克风', animation: 'mic' },
      { emoji: '🎧', name: '耳机', animation: 'headphone' },
      { emoji: '📢', name: '喇叭', animation: 'sound' },
      { emoji: '📣', name: '扩音器', animation: 'sound' },
      { emoji: '💢', name: '愤怒', animation: 'angry' },
      { emoji: '💧', name: '水滴', animation: 'drop' },
      { emoji: '💨', name: '风', animation: 'wind' },
      { emoji: '💤', name: '睡眠', animation: 'sleep' },
      { emoji: '❓', name: '问号', animation: 'bounce' },
      { emoji: '❌', name: '叉号', animation: 'bounce' },
      { emoji: '⚠️', name: '警告', animation: 'warn' },
      { emoji: '⛔', name: '禁止', animation: 'stop' },
      { emoji: '🚫', name: '禁止标志', animation: 'stop' },
      { emoji: '✅', name: '正确', animation: 'check' },
      { emoji: '✳️', name: '星号', animation: 'spin' },
      { emoji: '❇️', name: '闪亮星', animation: 'sparkle' },
      { emoji: '✴️', name: '八角星', animation: 'spin' },
      { emoji: '🔅', name: '弱光', animation: 'bright' },
      { emoji: '🔆', name: '强光', animation: 'bright' },
      { emoji: '💢', name: '青筋', animation: 'angry' },
    ]
  },
  {
    id: 'nature',
    name: '自然',
    icon: '🌹',
    emojis: [
      { emoji: '🌹', name: '玫瑰', animation: 'flower' },
      { emoji: '🌺', name: '木槿', animation: 'flower' },
      { emoji: '🌸', name: '樱花', animation: 'sakura' },
      { emoji: '🌻', name: '向日葵', animation: 'sunflower' },
      { emoji: '🌷', name: '郁金香', animation: 'flower' },
      { emoji: '🌼', name: '雏菊', animation: 'flower' },
      { emoji: '💐', name: '花束', animation: 'flower' },
      { emoji: '🌾', name: '稻穗', animation: 'wave' },
      { emoji: '🍀', name: '四叶草', animation: 'clover' },
      { emoji: '🍁', name: '枫叶', animation: 'leaf' },
      { emoji: '🍂', name: '落叶', animation: 'leaf' },
      { emoji: '🍃', name: '绿叶', animation: 'leaf' },
      { emoji: '🌿', name: '草药', animation: 'leaf' },
      { emoji: '🌱', name: '发芽', animation: 'grow' },
      { emoji: '🪴', name: '盆栽', animation: 'grow' },
      { emoji: '🌲', name: '松树', animation: 'tree' },
      { emoji: '🌳', name: '落叶树', animation: 'tree' },
      { emoji: '🌴', name: '棕榈树', animation: 'tree' },
      { emoji: '🌵', name: '仙人掌', animation: 'cactus' },
      { emoji: '🎋', name: '竹子', animation: 'bamboo' },
      { emoji: '🍄', name: '蘑菇', animation: 'mushroom' },
      { emoji: '🌙', name: '月亮', animation: 'moon' },
      { emoji: '⭐', name: '星星', animation: 'star' },
      { emoji: '🌟', name: '闪亮星', animation: 'twinkle' },
      { emoji: '✨', name: '闪烁', animation: 'sparkle' },
      { emoji: '☀️', name: '太阳', animation: 'sun' },
      { emoji: '🌤️', name: '晴转多云', animation: 'cloud' },
      { emoji: '⛅', name: '多云', animation: 'cloud' },
      { emoji: '🌥️', name: '多云转晴', animation: 'cloud' },
      { emoji: '☁️', name: '云', animation: 'cloud' },
      { emoji: '🌧️', name: '下雨', animation: 'rain' },
      { emoji: '⛈️', name: '雷雨', animation: 'thunder' },
      { emoji: '🌩️', name: '闪电', animation: 'thunder' },
      { emoji: '🌨️', name: '下雪', animation: 'snow' },
      { emoji: '❄️', name: '雪花', animation: 'snow' },
      { emoji: '🌪️', name: '龙卷风', animation: 'tornado' },
      { emoji: '🌈', name: '彩虹', animation: 'rainbow' },
      { emoji: '🌊', name: '海浪', animation: 'wave' },
      { emoji: '🌧️', name: '雨', animation: 'rain' },
      { emoji: '💧', name: '水滴', animation: 'drop' },
      { emoji: '🌫️', name: '雾', animation: 'fog' },
      { emoji: '🌬️', name: '风', animation: 'wind' },
      { emoji: '🗻', name: '富士山', animation: 'mountain' },
      { emoji: '⛰️', name: '山', animation: 'mountain' },
      { emoji: '🏔️', name: '雪山', animation: 'mountain' },
      { emoji: '🗼', name: '东京塔', animation: 'building' },
      { emoji: '🏕️', name: '露营', animation: 'camp' },
      { emoji: '🏖️', name: '海滩', animation: 'beach' },
      { emoji: '🏜️', name: '沙漠', animation: 'desert' },
      { emoji: '🏝️', name: '热带岛屿', animation: 'island' },
      { emoji: '🌋', name: '火山', animation: 'volcano' },
      { emoji: '🪨', name: '石头', animation: 'bounce' },
      { emoji: '🗿', name: '石像', animation: 'stone' },
      { emoji: '🌍', name: '地球', animation: 'globe' },
      { emoji: '🌎', name: '地球西', animation: 'globe' },
      { emoji: '🌏', name: '地球东', animation: 'globe' },
      { emoji: '🗺️', name: '地图', animation: 'map' },
      { emoji: '🧭', name: '指南针', animation: 'compass' },
      { emoji: '🌑', name: '新月', animation: 'moon' },
      { emoji: '🌒', name: '蛾眉月', animation: 'moon' },
      { emoji: '🌓', name: '上弦月', animation: 'moon' },
      { emoji: '🌔', name: '盈凸月', animation: 'moon' },
      { emoji: '🌕', name: '满月', animation: 'moon' },
      { emoji: '🌖', name: '亏凸月', animation: 'moon' },
      { emoji: '🌗', name: '下弦月', animation: 'moon' },
      { emoji: '🌘', name: '残月', animation: 'moon' },
      { emoji: '🌙', name: '弯月', animation: 'moon' },
      { emoji: '🌚', name: '黑月', animation: 'moon' },
      { emoji: '🌛', name: '上弦月脸', animation: 'moon' },
      { emoji: '🌜', name: '下弦月脸', animation: 'moon' },
      { emoji: '🌌', name: '银河', animation: 'galaxy' },
      { emoji: '🌠', name: '流星', animation: 'shooting' },
      { emoji: '⭐', name: '星星', animation: 'star' },
      { emoji: '🌟', name: '闪亮', animation: 'twinkle' },
      { emoji: '✨', name: '闪烁', animation: 'sparkle' },
    ]
  },
  {
    id: 'travel',
    name: '交通',
    icon: '🚗',
    emojis: [
      { emoji: '🚗', name: '汽车', animation: 'car' },
      { emoji: '🚕', name: '出租车', animation: 'car' },
      { emoji: '🚙', name: 'SUV', animation: 'car' },
      { emoji: '🚌', name: '公交车', animation: 'bus' },
      { emoji: '🚎', name: '电车', animation: 'bus' },
      { emoji: '🏎️', name: '赛车', animation: 'car' },
      { emoji: '🚓', name: '警车', animation: 'car' },
      { emoji: '🚑', name: '救护车', animation: 'car' },
      { emoji: '🚒', name: '消防车', animation: 'car' },
      { emoji: '🚜', name: '拖拉机', animation: 'car' },
      { emoji: '🛺', name: '三轮车', animation: 'car' },
      { emoji: '🚲', name: '自行车', animation: 'bike' },
      { emoji: '🚴', name: '骑行', animation: 'bike' },
      { emoji: '🛵', name: '摩托车', animation: 'bike' },
      { emoji: '🏍️', name: '重型摩托', animation: 'bike' },
      { emoji: '🚏', name: '公交站', animation: 'stop' },
      { emoji: '⛽', name: '加油站', animation: 'fuel' },
      { emoji: '🚧', name: '施工', animation: 'work' },
      { emoji: '🚦', name: '红绿灯', animation: 'light' },
      { emoji: '🚥', name: '人行横道', animation: 'walk' },
      { emoji: '✈️', name: '飞机', animation: 'fly' },
      { emoji: '🛫', name: '起飞', animation: 'fly' },
      { emoji: '🛬', name: '降落', animation: 'fly' },
      { emoji: '✈️', name: '客机', animation: 'fly' },
      { emoji: '🚀', name: '火箭', animation: 'rocket' },
      { emoji: '🛸', name: 'UFO', animation: 'ufo' },
      { emoji: '🚁', name: '直升机', animation: 'heli' },
      { emoji: '🛩️', name: '小型飞机', animation: 'fly' },
      { emoji: '🚢', name: '轮船', animation: 'ship' },
      { emoji: '⛵', name: '帆船', animation: 'sail' },
      { emoji: '🚤', name: '快艇', animation: 'boat' },
      { emoji: '🛳️', name: '邮轮', animation: 'ship' },
      { emoji: '⛴️', name: '渡轮', animation: 'ship' },
      { emoji: '🚂', name: '火车', animation: 'train' },
      { emoji: '🚃', name: '车厢', animation: 'train' },
      { emoji: '🚄', name: '高铁', animation: 'train' },
      { emoji: '🚅', name: '动车', animation: 'train' },
      { emoji: '🚆', name: '地铁', animation: 'train' },
      { emoji: '🚇', name: '地铁标志', animation: 'train' },
      { emoji: '🚈', name: '轻轨', animation: 'train' },
      { emoji: '🚉', name: '火车站', animation: 'station' },
      { emoji: '🚊', name: '电铁', animation: 'train' },
      { emoji: '🚝', name: '山铁', animation: 'train' },
      { emoji: '🚞', name: '窄轨', animation: 'train' },
      { emoji: '🚋', name: '有轨电车', animation: 'train' },
      { emoji: '🚌', name: '长途车', animation: 'bus' },
      { emoji: '🚍', name: '小型巴士', animation: 'bus' },
      { emoji: '🚎', name: '无轨电车', animation: 'bus' },
      { emoji: '🏠', name: '房子', animation: 'home' },
      { emoji: '🏡', name: '别墅', animation: 'home' },
      { emoji: '🏢', name: '办公楼', animation: 'building' },
      { emoji: '🏬', name: '商店', animation: 'building' },
      { emoji: '🏭', name: '工厂', animation: 'building' },
      { emoji: '🏯', name: '城堡', animation: 'castle' },
      { emoji: '🏰', name: '宫殿', animation: 'castle' },
      { emoji: '🗼', name: '塔', animation: 'building' },
      { emoji: '🏪', name: '便利店', animation: 'building' },
      { emoji: '🏫', name: '学校', animation: 'building' },
      { emoji: '🏥', name: '医院', animation: 'building' },
      { emoji: '🏦', name: '银行', animation: 'building' },
      { emoji: '🏨', name: '酒店', animation: 'building' },
      { emoji: '💒', name: '教堂', animation: 'building' },
      { emoji: '⛪', name: '大教堂', animation: 'building' },
      { emoji: '🏩', name: '民宿', animation: 'building' },
      { emoji: '🏤', name: '邮局', animation: 'building' },
      { emoji: '🏣', name: '市政厅', animation: 'building' },
    ]
  },
  {
    id: 'people',
    name: '人物',
    icon: '👶',
    emojis: [
      { emoji: '👶', name: '婴儿', animation: 'baby' },
      { emoji: '👧', name: '女孩', animation: 'wave' },
      { emoji: '👦', name: '男孩', animation: 'wave' },
      { emoji: '👩', name: '女人', animation: 'wave' },
      { emoji: '👨', name: '男人', animation: 'wave' },
      { emoji: '👵', name: '老奶奶', animation: 'wave' },
      { emoji: '👴', name: '老爷爷', animation: 'wave' },
      { emoji: '👱', name: '金发', animation: 'wave' },
      { emoji: '👸', name: '公主', animation: 'wave' },
      { emoji: '🤴', name: '王子', animation: 'wave' },
      { emoji: '👲', name: '中式', animation: 'wave' },
      { emoji: '🧕', name: '穆斯林', animation: 'wave' },
      { emoji: '👳', name: '锡克教', animation: 'wave' },
      { emoji: '🧔', name: '胡子', animation: 'wave' },
      { emoji: '👨‍🦰', name: '红发男', animation: 'wave' },
      { emoji: '👩‍🦰', name: '红发女', animation: 'wave' },
      { emoji: '👨‍🦱', name: '卷发男', animation: 'wave' },
      { emoji: '👩‍🦱', name: '卷发女', animation: 'wave' },
      { emoji: '👨‍🦳', name: '白发男', animation: 'wave' },
      { emoji: '👩‍🦳', name: '白发女', animation: 'wave' },
      { emoji: '👨‍🦲', name: '光头男', animation: 'wave' },
      { emoji: '👩‍🦲', name: '光头女', animation: 'wave' },
      { emoji: '🧑', name: '成人', animation: 'wave' },
      { emoji: '🧑‍🦰', name: '红发红人', animation: 'wave' },
      { emoji: '🧑‍🦱', name: '卷发红人', animation: 'wave' },
      { emoji: '🧑‍🦳', name: '白发红人', animation: 'wave' },
      { emoji: '🧑‍🦲', name: '光头红人', animation: 'wave' },
      { emoji: '👪', name: '家庭', animation: 'family' },
      { emoji: '👨‍👩‍👧', name: '三口之家', animation: 'family' },
      { emoji: '👨‍👩‍👧‍👦', name: '四口之家', animation: 'family' },
      { emoji: '👨‍👩‍👦‍👦', name: '两男娃', animation: 'family' },
      { emoji: '👨‍👩‍👧‍👧', name: '两女娃', animation: 'family' },
      { emoji: '👨‍👨‍👧', name: '同性家庭', animation: 'family' },
      { emoji: '👩‍👩‍👧', name: '同性家庭', animation: 'family' },
      { emoji: '👨‍👨‍👧‍👦', name: '同性家庭', animation: 'family' },
      { emoji: '👩‍👩‍👧‍👦', name: '同性家庭', animation: 'family' },
      { emoji: '👨‍👨‍👦', name: '同性家庭', animation: 'family' },
      { emoji: '👩‍👩‍👦', name: '同性家庭', animation: 'family' },
      { emoji: '👨‍👨‍👦‍👦', name: '同性家庭', animation: 'family' },
      { emoji: '👩‍👩‍👧‍👧', name: '同性家庭', animation: 'family' },
      { emoji: '👴‍👵', name: '老两口', animation: 'couple' },
      { emoji: '👵‍👴', name: '老两口', animation: 'couple' },
      { emoji: '👩‍❤️‍👨', name: '情侣', animation: 'couple' },
      { emoji: '👨‍❤️‍👨', name: '同性情侣', animation: 'couple' },
      { emoji: '👩‍❤️‍👩', name: '同性情侣', animation: 'couple' },
      { emoji: '💑', name: '夫妻', animation: 'couple' },
      { emoji: '👫', name: '男女', animation: 'couple' },
      { emoji: '👬', name: '男男', animation: 'couple' },
      { emoji: '👭', name: '女女', animation: 'couple' },
      { emoji: '🙍', name: '皱眉', animation: 'frown' },
      { emoji: '🙍‍♀️', name: '皱眉女', animation: 'frown' },
      { emoji: '🙍‍♂️', name: '皱眉男', animation: 'frown' },
      { emoji: '🙎', name: '不高兴', animation: 'frown' },
      { emoji: '🙎‍♀️', name: '不高兴女', animation: 'frown' },
      { emoji: '🙎‍♂️', name: '不高兴男', animation: 'frown' },
      { emoji: '🙋', name: '举手', animation: 'raise' },
      { emoji: '🙋‍♀️', name: '举手女', animation: 'raise' },
      { emoji: '🙋‍♂️', name: '举手男', animation: 'raise' },
      { emoji: '🙌', name: '举手庆祝', animation: 'raise' },
      { emoji: '🙏', name: '祈祷', animation: 'pray' },
      { emoji: '🤚', name: '手掌', animation: 'stop' },
      { emoji: '👋', name: '挥手', animation: 'wave' },
      { emoji: '✋', name: '停止', animation: 'stop' },
      { emoji: '🤝', name: '握手', animation: 'shakehand' },
      { emoji: '👍', name: '点赞', animation: 'thumbsup' },
      { emoji: '👎', name: '差评', animation: 'thumbsdown' },
      { emoji: '👏', name: '鼓掌', animation: 'clap' },
      { emoji: '💪', name: '肌肉', animation: 'flex' },
      { emoji: '👊', name: '加油', animation: 'punch' },
      { emoji: '🤛', name: '左勾拳', animation: 'punch' },
      { emoji: '🤜', name: '右勾拳', animation: 'punch' },
      { emoji: '🖕', name: '中指', animation: 'finger' },
      { emoji: '✌️', name: '胜利', animation: 'victory' },
      { emoji: '🤞', name: '幸运', animation: 'cross' },
      { emoji: '🤟', name: '爱你', animation: 'ily' },
      { emoji: '🤘', name: '摇滚', animation: 'rock' },
      { emoji: '👌', name: '完美', animation: 'ok' },
      { emoji: '👈', name: '指向左', animation: 'point' },
      { emoji: '👉', name: '指向右', animation: 'point' },
      { emoji: '👆', name: '指向上', animation: 'point' },
      { emoji: '👇', name: '指向下方', animation: 'point' },
      { emoji: '☝️', name: '一指', animation: 'point' },
      { emoji: '✋', name: '手掌', animation: 'stop' },
      { emoji: '🖖', name: '瓦肯', animation: 'vulcan' },
      { emoji: '🤚', name: '开掌', animation: 'stop' },
      { emoji: '🖐️', name: '五指', animation: 'stop' },
      { emoji: '🤙', name: '打电话', animation: 'call' },
      { emoji: '💅', name: '美甲', animation: 'nail' },
      { emoji: '🤳', name: '自拍', animation: 'selfie' },
      { emoji: '💪', name: '二头肌', animation: 'flex' },
      { emoji: '🦵', name: '腿', animation: 'leg' },
      { emoji: '🦶', name: '脚', animation: 'foot' },
      { emoji: '👂', name: '耳朵', animation: 'ear' },
      { emoji: '🦻', name: '助听器', animation: 'ear' },
      { emoji: '👃', name: '鼻子', animation: 'nose' },
      { emoji: '👄', name: '嘴唇', animation: 'lips' },
      { emoji: '👅', name: '舌头', animation: 'tongue' },
      { emoji: '👀', name: '眼睛', animation: 'eyes' },
      { emoji: '👁️', name: '眼睛', animation: 'eye' },
      { emoji: '🧠', name: '大脑', animation: 'brain' },
      { emoji: '🫀', name: '心脏', animation: 'heartbeat' },
      { emoji: '🫁', name: '肺', animation: 'breathe' },
      { emoji: '🦴', name: '骨头', animation: 'bone' },
      { emoji: '👋', name: '挥手再见', animation: 'wave' },
    ]
  },
  {
    id: 'flags',
    name: '旗帜',
    icon: '🇨🇳',
    emojis: [
      { emoji: '🇨🇳', name: '中国', animation: 'wave' },
      { emoji: '🇺🇸', name: '美国', animation: 'wave' },
      { emoji: '🇯🇵', name: '日本', animation: 'wave' },
      { emoji: '🇰🇷', name: '韩国', animation: 'wave' },
      { emoji: '🇬🇧', name: '英国', animation: 'wave' },
      { emoji: '🇫🇷', name: '法国', animation: 'wave' },
      { emoji: '🇩🇪', name: '德国', animation: 'wave' },
      { emoji: '🇮🇹', name: '意大利', animation: 'wave' },
      { emoji: '🇪🇸', name: '西班牙', animation: 'wave' },
      { emoji: '🇵🇹', name: '葡萄牙', animation: 'wave' },
      { emoji: '🇧🇷', name: '巴西', animation: 'wave' },
      { emoji: '🇷🇺', name: '俄罗斯', animation: 'wave' },
      { emoji: '🇮🇳', name: '印度', animation: 'wave' },
      { emoji: '🇦🇺', name: '澳大利亚', animation: 'wave' },
      { emoji: '🇨🇦', name: '加拿大', animation: 'wave' },
      { emoji: '🇲🇽', name: '墨西哥', animation: 'wave' },
      { emoji: '🇳🇱', name: '荷兰', animation: 'wave' },
      { emoji: '🇸🇪', name: '瑞典', animation: 'wave' },
      { emoji: '🇳🇴', name: '挪威', animation: 'wave' },
      { emoji: '🇩🇰', name: '丹麦', animation: 'wave' },
      { emoji: '🇫🇮', name: '芬兰', animation: 'wave' },
      { emoji: '🇨🇭', name: '瑞士', animation: 'wave' },
      { emoji: '🇦🇹', name: '奥地利', animation: 'wave' },
      { emoji: '🇵🇱', name: '波兰', animation: 'wave' },
      { emoji: '🇭🇺', name: '匈牙利', animation: 'wave' },
      { emoji: '🇷🇴', name: '罗马尼亚', animation: 'wave' },
      { emoji: '🇧🇬', name: '保加利亚', animation: 'wave' },
      { emoji: '🇬🇷', name: '希腊', animation: 'wave' },
      { emoji: '🇹🇷', name: '土耳其', animation: 'wave' },
      { emoji: '🇮🇱', name: '以色列', animation: 'wave' },
      { emoji: '🇸🇦', name: '沙特', animation: 'wave' },
      { emoji: '🇦🇪', name: '阿联酋', animation: 'wave' },
      { emoji: '🇮🇩', name: '印尼', animation: 'wave' },
      { emoji: '🇹🇭', name: '泰国', animation: 'wave' },
      { emoji: '🇻🇳', name: '越南', animation: 'wave' },
      { emoji: '🇲🇾', name: '马来西亚', animation: 'wave' },
      { emoji: '🇸🇬', name: '新加坡', animation: 'wave' },
      { emoji: '🇦🇷', name: '阿根廷', animation: 'wave' },
      { emoji: '🇨🇱', name: '智利', animation: 'wave' },
      { emoji: '🇵🇪', name: '秘鲁', animation: 'wave' },
      { emoji: '🇨🇺', name: '古巴', animation: 'wave' },
      { emoji: '🇯🇲', name: '牙买加', animation: 'wave' },
      { emoji: '🇳🇬', name: '尼日利亚', animation: 'wave' },
      { emoji: '🇿🇦', name: '南非', animation: 'wave' },
      { emoji: '🇪🇬', name: '埃及', animation: 'wave' },
      { emoji: '🇲🇦', name: '摩洛哥', animation: 'wave' },
      { emoji: '🏳️', name: '白旗', animation: 'wave' },
      { emoji: '🏴', name: '黑旗', animation: 'wave' },
      { emoji: '🏳️‍🌈', name: '彩虹旗', animation: 'wave' },
      { emoji: '🚩', name: '三角旗', animation: 'wave' },
      { emoji: '🎌', name: '交叉旗', animation: 'wave' },
    ]
  },
  {
    id: 'objects',
    name: '物品',
    icon: '💎',
    emojis: [
      { emoji: '💎', name: '钻石', animation: 'sparkle' },
      { emoji: '👑', name: '皇冠', animation: 'sparkle' },
      { emoji: '🏆', name: '奖杯', animation: 'trophy' },
      { emoji: '🎖️', name: '奖章', animation: 'bounce' },
      { emoji: '🏅', name: '奖牌', animation: 'bounce' },
      { emoji: '🥇', name: '金牌', animation: 'sparkle' },
      { emoji: '🥈', name: '银牌', animation: 'sparkle' },
      { emoji: '🥉', name: '铜牌', animation: 'sparkle' },
      { emoji: '⚽', name: '足球', animation: 'bounce' },
      { emoji: '🏀', name: '篮球', animation: 'bounce' },
      { emoji: '🏈', name: '橄榄球', animation: 'bounce' },
      { emoji: '⚾', name: '棒球', animation: 'bounce' },
      { emoji: '🎾', name: '网球', animation: 'bounce' },
      { emoji: '🏐', name: '排球', animation: 'bounce' },
      { emoji: '🏓', name: '乒乓球', animation: 'bounce' },
      { emoji: '🏸', name: '羽毛球', animation: 'bounce' },
      { emoji: '🎱', name: '台球', animation: 'roll' },
      { emoji: '🎳', name: '保龄球', animation: 'roll' },
      { emoji: '🎮', name: '游戏', animation: 'game' },
      { emoji: '🎲', name: '骰子', animation: 'roll' },
      { emoji: '🃏', name: '扑克牌', animation: 'flip' },
      { emoji: '🎴', name: '花牌', animation: 'flip' },
      { emoji: '♠️', name: '黑桃', animation: 'bounce' },
      { emoji: '♥️', name: '红心', animation: 'heartbeat' },
      { emoji: '♦️', name: '方块', animation: 'bounce' },
      { emoji: '♣️', name: '梅花', animation: 'bounce' },
      { emoji: '💵', name: '美元', animation: 'money' },
      { emoji: '💴', name: '日元', animation: 'money' },
      { emoji: '💶', name: '欧元', animation: 'money' },
      { emoji: '💷', name: '英镑', animation: 'money' },
      { emoji: '💰', name: '钱袋', animation: 'money' },
      { emoji: '🪙', name: '硬币', animation: 'bounce' },
      { emoji: '💳', name: '信用卡', animation: 'flip' },
      { emoji: '📱', name: '手机', animation: 'bounce' },
      { emoji: '📲', name: '手机信号', animation: 'bounce' },
      { emoji: '💻', name: '电脑', animation: 'bounce' },
      { emoji: '🖥️', name: '显示器', animation: 'bounce' },
      { emoji: '⌨️', name: '键盘', animation: 'bounce' },
      { emoji: '🖱️', name: '鼠标', animation: 'bounce' },
      { emoji: '🎧', name: '耳机', animation: 'headphone' },
      { emoji: '🎤', name: '麦克风', animation: 'mic' },
      { emoji: '🎙️', name: '话筒', animation: 'mic' },
      { emoji: '🎚️', name: '调音台', animation: 'music' },
      { emoji: '📷', name: '相机', animation: 'bounce' },
      { emoji: '📸', name: '拍照', animation: 'bounce' },
      { emoji: '📹', name: '摄像机', animation: 'bounce' },
      { emoji: '📺', name: '电视', animation: 'bounce' },
      { emoji: '📻', name: '收音机', animation: 'sound' },
      { emoji: '📡', name: '信号塔', animation: 'wave' },
      { emoji: '🔋', name: '电池', animation: 'bounce' },
      { emoji: '🔌', name: '插头', animation: 'bounce' },
      { emoji: '💡', name: '灯泡', animation: 'bright' },
      { emoji: '🔦', name: '手电筒', animation: 'bright' },
      { emoji: '🕯️', name: '蜡烛', animation: 'flicker' },
      { emoji: '🗂️', name: '文件夹', animation: 'bounce' },
      { emoji: '📁', name: '目录', animation: 'bounce' },
      { emoji: '📂', name: '打开文件夹', animation: 'bounce' },
      { emoji: '📄', name: '文件', animation: 'flip' },
      { emoji: '📑', name: '文件标签', animation: 'flip' },
      { emoji: '📊', name: '图表', animation: 'bounce' },
      { emoji: '📈', name: '上升', animation: 'bounce' },
      { emoji: '📉', name: '下降', animation: 'bounce' },
      { emoji: '📋', name: '清单', animation: 'flip' },
      { emoji: '📝', name: '便签', animation: 'bounce' },
      { emoji: '✏️', name: '铅笔', animation: 'write' },
      { emoji: '✒️', name: '钢笔', animation: 'write' },
      { emoji: '🖋️', name: '毛笔', animation: 'write' },
      { emoji: '🖊️', name: '圆珠笔', animation: 'write' },
      { emoji: '📚', name: '书本', animation: 'bounce' },
      { emoji: '📖', name: '打开的书', animation: 'flip' },
      { emoji: '📕', name: '红书', animation: 'bounce' },
      { emoji: '📗', name: '绿书', animation: 'bounce' },
      { emoji: '📘', name: '蓝书', animation: 'bounce' },
      { emoji: '📙', name: '黄书', animation: 'bounce' },
      { emoji: '📔', name: '笔记本', animation: 'bounce' },
      { emoji: '📒', name: '带笔笔记本', animation: 'bounce' },
      { emoji: '📓', name: '横格本', animation: 'bounce' },
      { emoji: '📃', name: '纸张', animation: 'flip' },
      { emoji: '🔖', name: '书签', animation: 'bounce' },
      { emoji: '🏷️', name: '标签', animation: 'bounce' },
      { emoji: '📌', name: '图钉', animation: 'bounce' },
      { emoji: '📍', name: '定位', animation: 'bounce' },
      { emoji: '📎', name: '回形针', animation: 'bounce' },
      { emoji: '🖇️', name: '夹子', animation: 'bounce' },
      { emoji: '📐', name: '三角尺', animation: 'bounce' },
      { emoji: '📏', name: '直尺', animation: 'bounce' },
      { emoji: '🧮', name: '算盘', animation: 'bounce' },
      { emoji: '🔬', name: '显微镜', animation: 'bounce' },
      { emoji: '🔭', name: '望远镜', animation: 'bounce' },
      { emoji: '🕰️', name: '座钟', animation: 'spin' },
      { emoji: '⏰', name: '闹钟', animation: 'ring' },
      { emoji: '⏱️', name: '计时器', animation: 'spin' },
      { emoji: '⏲️', name: '定时器', animation: 'spin' },
      { emoji: '📆', name: '日历', animation: 'flip' },
      { emoji: '📅', name: '日期', animation: 'flip' },
      { emoji: '🗓️', name: '日程', animation: 'flip' },
      { emoji: '🎁', name: '礼物', animation: 'gift' },
      { emoji: '🎀', name: '蝴蝶结', animation: 'bounce' },
      { emoji: '🎈', name: '气球', animation: 'float' },
      { emoji: '🎉', name: '庆祝', animation: 'party' },
      { emoji: '🎊', name: '彩带', animation: 'confetti' },
      { emoji: '🎪', name: '马戏团', animation: 'bounce' },
      { emoji: '🎭', name: '面具', animation: 'flip' },
      { emoji: '🎨', name: '调色板', animation: 'bounce' },
      { emoji: '🖼️', name: '画框', animation: 'bounce' },
      { emoji: '🎯', name: '靶子', animation: 'target' },
      { emoji: '🎰', name: '老虎机', animation: 'spin' },
      { emoji: '🎲', name: '色子', animation: 'roll' },
      { emoji: '🔮', name: '水晶球', animation: 'sparkle' },
      { emoji: '🧿', name: '邪眼', animation: 'sparkle' },
      { emoji: '💈', name: '理发店', animation: 'spin' },
      { emoji: '🚬', name: '香烟', animation: 'smoke' },
      { emoji: '💊', name: '药丸', animation: 'bounce' },
      { emoji: '🩹', name: '创可贴', animation: 'bounce' },
      { emoji: '🏥', name: '医院', animation: 'building' },
      { emoji: '🚑', name: '救护车', animation: 'car' },
      { emoji: '🔑', name: '钥匙', animation: 'bounce' },
      { emoji: '🗝️', name: '金钥匙', animation: 'bounce' },
      { emoji: '🗄️', name: '文件柜', animation: 'bounce' },
      { emoji: '🗃️', name: '档案柜', animation: 'bounce' },
      { emoji: '📦', name: '箱子', animation: 'bounce' },
      { emoji: '📥', name: '收件箱', animation: 'bounce' },
      { emoji: '📤', name: '发件箱', animation: 'bounce' },
      { emoji: '📬', name: '邮箱', animation: 'bounce' },
      { emoji: '📭', name: '开邮箱', animation: 'bounce' },
      { emoji: '📮', name: '邮筒', animation: 'bounce' },
      { emoji: '✉️', name: '信封', animation: 'bounce' },
      { emoji: '📧', name: '邮件', animation: 'bounce' },
      { emoji: '💌', name: '情书', animation: 'heartbeat' },
      { emoji: '📩', name: '收到邮件', animation: 'bounce' },
      { emoji: '📨', name: '发送邮件', animation: 'bounce' },
      { emoji: '📯', name: '喇叭', animation: 'sound' },
      { emoji: '📢', name: '扬声器', animation: 'sound' },
      { emoji: '📣', name: '扩音器', animation: 'sound' },
      { emoji: '🔔', name: '铃铛', animation: 'ring' },
      { emoji: '🔕', name: '静音', animation: 'stop' },
      { emoji: '🔊', name: '大声', animation: 'sound' },
      { emoji: '🔉', name: '中等', animation: 'sound' },
      { emoji: '🔈', name: '小声', animation: 'sound' },
      { emoji: '🔇', name: '静音', animation: 'stop' },
    ]
  },
  {
    id: 'sports',
    name: '运动',
    icon: '⚽',
    emojis: [
      { emoji: '⚽', name: '足球', animation: 'bounce' },
      { emoji: '🏀', name: '篮球', animation: 'bounce' },
      { emoji: '🏈', name: '橄榄球', animation: 'bounce' },
      { emoji: '⚾', name: '棒球', animation: 'bounce' },
      { emoji: '🎾', name: '网球', animation: 'bounce' },
      { emoji: '🏐', name: '排球', animation: 'bounce' },
      { emoji: '🏓', name: '乒乓球', animation: 'bounce' },
      { emoji: '🏸', name: '羽毛球', animation: 'bounce' },
      { emoji: '🎱', name: '台球', animation: 'roll' },
      { emoji: '🎳', name: '保龄球', animation: 'roll' },
      { emoji: '🏏', name: '板球', animation: 'bounce' },
      { emoji: '🏑', name: '曲棍球', animation: 'bounce' },
      { emoji: '🏒', name: '冰球', animation: 'bounce' },
      { emoji: '🥊', name: '拳击', animation: 'punch' },
      { emoji: '🥋', name: '武术', animation: 'flex' },
      { emoji: '⚔️', name: '剑', animation: 'swing' },
      { emoji: '🛡️', name: '盾牌', animation: 'bounce' },
      { emoji: '🏹', name: '射箭', animation: 'bounce' },
      { emoji: '🎣', name: '钓鱼', animation: 'bounce' },
      { emoji: '🤿', name: '潜水', animation: 'swim' },
      { emoji: '🏊', name: '游泳', animation: 'swim' },
      { emoji: '🏄', name: '冲浪', animation: 'wave' },
      { emoji: '🏂', name: '滑雪', animation: 'slide' },
      { emoji: '🎿', name: '滑雪板', animation: 'slide' },
      { emoji: '⛷️', name: '滑雪', animation: 'slide' },
      { emoji: '🏌️', name: '高尔夫', animation: 'swing' },
      { emoji: '🚣', name: '划船', animation: 'row' },
      { emoji: '🏊‍♂️', name: '男游泳', animation: 'swim' },
      { emoji: '🏊‍♀️', name: '女游泳', animation: 'swim' },
      { emoji: '🏄‍♂️', name: '男冲浪', animation: 'wave' },
      { emoji: '🏄‍♀️', name: '女冲浪', animation: 'wave' },
      { emoji: '🏂‍♂️', name: '男滑雪', animation: 'slide' },
      { emoji: '🏂‍♀️', name: '女滑雪', animation: 'slide' },
      { emoji: '🏌️‍♂️', name: '男高尔夫', animation: 'swing' },
      { emoji: '🏌️‍♀️', name: '女高尔夫', animation: 'swing' },
      { emoji: '🚣‍♂️', name: '男划船', animation: 'row' },
      { emoji: '🚣‍♀️', name: '女划船', animation: 'row' },
      { emoji: '🚴', name: '骑车', animation: 'bike' },
      { emoji: '🚴‍♂️', name: '男骑车', animation: 'bike' },
      { emoji: '🚴‍♀️', name: '女骑车', animation: 'bike' },
      { emoji: '🏃', name: '跑步', animation: 'run' },
      { emoji: '🏃‍♂️', name: '男跑步', animation: 'run' },
      { emoji: '🏃‍♀️', name: '女跑步', animation: 'run' },
      { emoji: '🚶', name: '走路', animation: 'walk' },
      { emoji: '🚶‍♂️', name: '男走路', animation: 'walk' },
      { emoji: '🚶‍♀️', name: '女走路', animation: 'walk' },
      { emoji: '🧗', name: '攀岩', animation: 'climb' },
      { emoji: '🧗‍♂️', name: '男攀岩', animation: 'climb' },
      { emoji: '🧗‍♀️', name: '女攀岩', animation: 'climb' },
      { emoji: '🤸', name: '翻跟头', animation: 'flip' },
      { emoji: '🤸‍♂️', name: '男翻跟头', animation: 'flip' },
      { emoji: '🤸‍♀️', name: '女翻跟头', animation: 'flip' },
      { emoji: '🏆', name: '奖杯', animation: 'trophy' },
      { emoji: '🥇', name: '金牌', animation: 'sparkle' },
      { emoji: '🥈', name: '银牌', animation: 'sparkle' },
      { emoji: '🥉', name: '铜牌', animation: 'sparkle' },
      { emoji: '🎖️', name: '奖章', animation: 'bounce' },
      { emoji: '🏅', name: '奖牌', animation: 'bounce' },
      { emoji: '⚽️', name: '足球', animation: 'bounce' },
      { emoji: '🏀️', name: '篮球', animation: 'bounce' },
      { emoji: '🏈️', name: '橄榄球', animation: 'bounce' },
      { emoji: '⚾️', name: '棒球', animation: 'bounce' },
      { emoji: '🎾️', name: '网球', animation: 'bounce' },
      { emoji: '🏐️', name: '排球', animation: 'bounce' },
      { emoji: '🏓️', name: '乒乓球', animation: 'bounce' },
      { emoji: '🏸️', name: '羽毛球', animation: 'bounce' },
    ]
  },
  {
    id: 'holidays',
    name: '节日',
    icon: '🎄',
    emojis: [
      { emoji: '🎄', name: '圣诞树', animation: 'sparkle' },
      { emoji: '🎅', name: '圣诞老人', animation: 'wave' },
      { emoji: '🤶', name: '圣诞奶奶', animation: 'wave' },
      { emoji: '🎁', name: '礼物', animation: 'gift' },
      { emoji: '🎀', name: '蝴蝶结', animation: 'bounce' },
      { emoji: '🎈', name: '气球', animation: 'float' },
      { emoji: '🎉', name: '庆祝', animation: 'party' },
      { emoji: '🎊', name: '彩带', animation: 'confetti' },
      { emoji: '🎆', name: '烟花', animation: 'explode' },
      { emoji: '🎇', name: '焰火', animation: 'explode' },
      { emoji: '🧨', name: '鞭炮', animation: 'explode' },
      { emoji: '🏮', name: '灯笼', animation: 'float' },
      { emoji: '🎑', name: '中秋', animation: 'moon' },
      { emoji: '🐉', name: '龙', animation: 'wiggle' },
      { emoji: '🧧', name: '红包', animation: 'money' },
      { emoji: '🦁', name: '狮子', animation: 'lion' },
      { emoji: '🎭', name: '面具', animation: 'flip' },
      { emoji: '🎪', name: '马戏团', animation: 'bounce' },
      { emoji: '🎡', name: '摩天轮', animation: 'spin' },
      { emoji: '🎢', name: '过山车', animation: 'spin' },
      { emoji: '🎠', name: '旋转木马', animation: 'spin' },
      { emoji: '🎟️', name: '门票', animation: 'flip' },
      { emoji: '🎪', name: '帐篷', animation: 'bounce' },
      { emoji: '🍬', name: '糖果', animation: 'bounce' },
      { emoji: '🍭', name: '棒棒糖', animation: 'spin' },
      { emoji: '🍪', name: '饼干', animation: 'crunch' },
      { emoji: '🎂', name: '蛋糕', animation: 'sparkle' },
      { emoji: '🍰', name: '蛋糕片', animation: 'bounce' },
      { emoji: '🧁', name: '纸杯蛋糕', animation: 'bounce' },
      { emoji: '🍩', name: '甜甜圈', animation: 'roll' },
      { emoji: '🍫', name: '巧克力', animation: 'melt' },
      { emoji: '🍿', name: '爆米花', animation: 'pop' },
      { emoji: '🎃', name: '南瓜', animation: 'bounce' },
      { emoji: '👻', name: '幽灵', animation: 'float' },
      { emoji: '🧛', name: '吸血鬼', animation: 'wiggle' },
      { emoji: '🧟', name: '僵尸', animation: 'walk' },
      { emoji: '💀', name: '骷髅', animation: 'shake' },
      { emoji: '🦇', name: '蝙蝠', animation: 'fly' },
      { emoji: '🕷️', name: '蜘蛛', animation: 'crawl' },
      { emoji: '🕸️', name: '蜘蛛网', animation: 'spin' },
      { emoji: '🎃', name: '万圣节', animation: 'bounce' },
      { emoji: '🦄', name: '独角兽', animation: 'unicorn' },
      { emoji: '🐰', name: '复活节兔', animation: 'bunny' },
      { emoji: '🐣', name: '复活节蛋', animation: 'bounce' },
      { emoji: '🌸', name: '樱花', animation: 'sakura' },
      { emoji: '🎋', name: '七夕', animation: 'bamboo' },
      { emoji: '💝', name: '礼物心', animation: 'gift' },
      { emoji: '💕', name: '两颗心', animation: 'heartfloat' },
      { emoji: '💞', name: '旋转心', animation: 'heartfloat' },
      { emoji: '💓', name: '跳动心', animation: 'heartbeat' },
      { emoji: '💗', name: '成长心', animation: 'heartbeat' },
      { emoji: '💖', name: '闪亮心', animation: 'sparkle' },
      { emoji: '💘', name: '丘比特', animation: 'cupid' },
      { emoji: '💝', name: '礼物', animation: 'gift' },
      { emoji: '🌹', name: '玫瑰', animation: 'flower' },
      { emoji: '🥀', name: '枯萎玫瑰', animation: 'flower' },
      { emoji: '💐', name: '花束', animation: 'flower' },
      { emoji: '🌸', name: '花', animation: 'flower' },
      { emoji: '🌺', name: '木槿', animation: 'flower' },
      { emoji: '🌻', name: '向日葵', animation: 'sunflower' },
      { emoji: '🌷', name: '郁金香', animation: 'flower' },
      { emoji: '🌼', name: '雏菊', animation: 'flower' },
    ]
  },
];

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
  onClose: () => void;
}

const getAnimationClass = (animation?: string): string => {
  switch (animation) {
    case 'bounce': return 'animate-bounce';
    case 'shake': return 'animate-shake';
    case 'roll': return 'animate-roll';
    case 'pulse': return 'animate-pulse';
    case 'sweat': return 'animate-sweat';
    case 'peek': return 'animate-peek';
    case 'halo': return 'animate-halo';
    case 'heartbeat': return 'animate-heartbeat';
    case 'sparkle': return 'animate-sparkle';
    case 'twinkle': return 'animate-twinkle';
    case 'blow': return 'animate-blow';
    case 'yum': return 'animate-yum';
    case 'wiggle': return 'animate-wiggle';
    case 'wink': return 'animate-wink';
    case 'tilt': return 'animate-tilt';
    case 'worry': return 'animate-worry';
    case 'frown': return 'animate-frown';
    case 'pop': return 'animate-pop';
    case 'shock': return 'animate-shock';
    case 'crybaby': return 'animate-crybaby';
    case 'tremble': return 'animate-tremble';
    case 'cry': return 'animate-cry';
    case 'bawling': return 'animate-bawling';
    case 'scream': return 'animate-scream';
    case 'spin': return 'animate-spin';
    case 'explode': return 'animate-explode';
    case 'thumbsup': return 'animate-thumbsup';
    case 'thumbsdown': return 'animate-thumbsdown';
    case 'clap': return 'animate-clap';
    case 'raise': return 'animate-raise';
    case 'wave': return 'animate-wave';
    case 'stop': return 'animate-stop';
    case 'shakehand': return 'animate-shakehand';
    case 'flex': return 'animate-flex';
    case 'victory': return 'animate-victory';
    case 'rock': return 'animate-rock';
    case 'ok': return 'animate-ok';
    case 'pray': return 'animate-pray';
    case 'ily': return 'animate-ily';
    case 'cross': return 'animate-cross';
    case 'punch': return 'animate-punch';
    case 'vulcan': return 'animate-vulcan';
    case 'monkey': return 'animate-monkey';
    case 'dog': return 'animate-dog';
    case 'cat': return 'animate-cat';
    case 'lion': return 'animate-lion';
    case 'tiger': return 'animate-tiger';
    case 'bear': return 'animate-bear';
    case 'panda': return 'animate-panda';
    case 'fox': return 'animate-fox';
    case 'bunny': return 'animate-bunny';
    case 'frog': return 'animate-frog';
    case 'chicken': return 'animate-chicken';
    case 'pig': return 'animate-pig';
    case 'cow': return 'animate-cow';
    case 'bee': return 'animate-bee';
    case 'butterfly': return 'animate-butterfly';
    case 'unicorn': return 'animate-unicorn';
    case 'crunch': return 'animate-crunch';
    case 'melt': return 'animate-melt';
    case 'steam': return 'animate-steam';
    case 'bubble': return 'animate-bubble';
    case 'swirl': return 'animate-swirl';
    case 'slice': return 'animate-slice';
    case 'juicy': return 'animate-juicy';
    case 'heartfloat': return 'animate-heartfloat';
    case 'cupid': return 'animate-cupid';
    case 'gift': return 'animate-gift';
    case 'perfect': return 'animate-perfect';
    case 'fire': return 'animate-fire';
    case 'boom': return 'animate-boom';
    case 'party': return 'animate-party';
    case 'confetti': return 'animate-confetti';
    case 'flower': return 'animate-flower';
    case 'sakura': return 'animate-sakura';
    case 'sunflower': return 'animate-sunflower';
    case 'moon': return 'animate-moon';
    case 'star': return 'animate-star';
    case 'sun': return 'animate-sun';
    case 'rainbow': return 'animate-rainbow';
    case 'cloud': return 'animate-cloud';
    case 'rain': return 'animate-rain';
    case 'snow': return 'animate-snow';
    case 'clover': return 'animate-clover';
    case 'leaf': return 'animate-leaf';
    case 'car': return 'animate-car';
    case 'bus': return 'animate-bus';
    case 'bike': return 'animate-bike';
    case 'fly': return 'animate-fly';
    case 'ship': return 'animate-ship';
    case 'train': return 'animate-train';
    case 'rocket': return 'animate-rocket';
    case 'heli': return 'animate-heli';
    case 'ufo': return 'animate-ufo';
    case 'sail': return 'animate-sail';
    case 'boat': return 'animate-boat';
    case 'building': return 'animate-building';
    case 'castle': return 'animate-castle';
    case 'home': return 'animate-home';
    case 'family': return 'animate-family';
    case 'couple': return 'animate-couple';
    case 'baby': return 'animate-baby';
    case 'wave': return 'animate-wave';
    case 'point': return 'animate-point';
    case 'finger': return 'animate-finger';
    case 'call': return 'animate-call';
    case 'nail': return 'animate-nail';
    case 'selfie': return 'animate-selfie';
    case 'leg': return 'animate-leg';
    case 'foot': return 'animate-foot';
    case 'ear': return 'animate-ear';
    case 'nose': return 'animate-nose';
    case 'lips': return 'animate-lips';
    case 'tongue': return 'animate-tongue';
    case 'eyes': return 'animate-eyes';
    case 'eye': return 'animate-eye';
    case 'brain': return 'animate-brain';
    case 'breathe': return 'animate-breathe';
    case 'bone': return 'animate-bone';
    case 'sound': return 'animate-sound';
    case 'mic': return 'animate-mic';
    case 'headphone': return 'animate-headphone';
    case 'music': return 'animate-music';
    case 'piano': return 'animate-piano';
    case 'guitar': return 'animate-guitar';
    case 'drum': return 'animate-drum';
    case 'trophy': return 'animate-trophy';
    case 'target': return 'animate-target';
    case 'game': return 'animate-game';
    case 'flip': return 'animate-flip';
    case 'wind': return 'animate-wind';
    case 'drop': return 'animate-drop';
    case 'sleep': return 'animate-sleep';
    case 'cold': return 'animate-cold';
    case 'hot': return 'animate-hot';
    case 'drunk': return 'animate-drunk';
    case 'sick': return 'animate-sick';
    case 'hurt': return 'animate-hurt';
    case 'tired': return 'animate-tired';
    case 'angry': return 'animate-angry';
    case 'float': return 'animate-float';
    case 'tree': return 'animate-tree';
    case 'cactus': return 'animate-cactus';
    case 'bamboo': return 'animate-bamboo';
    case 'mushroom': return 'animate-mushroom';
    case 'grow': return 'animate-grow';
    case 'thunder': return 'animate-thunder';
    case 'tornado': return 'animate-tornado';
    case 'fog': return 'animate-fog';
    case 'mountain': return 'animate-mountain';
    case 'camp': return 'animate-camp';
    case 'beach': return 'animate-beach';
    case 'desert': return 'animate-desert';
    case 'island': return 'animate-island';
    case 'volcano': return 'animate-volcano';
    case 'globe': return 'animate-globe';
    case 'map': return 'animate-map';
    case 'compass': return 'animate-compass';
    case 'galaxy': return 'animate-galaxy';
    case 'shooting': return 'animate-shooting';
    case 'fuel': return 'animate-fuel';
    case 'work': return 'animate-work';
    case 'light': return 'animate-light';
    case 'walk': return 'animate-walk';
    case 'station': return 'animate-station';
    case 'fuel': return 'animate-fuel';
    case 'break': return 'animate-break';
    case 'warn': return 'animate-warn';
    case 'check': return 'animate-check';
    case 'bright': return 'animate-bright';
    case 'snow': return 'animate-snow';
    case 'fish': return 'animate-fish';
    case 'squid': return 'animate-squid';
    case 'crab': return 'animate-crab';
    case 'octopus': return 'animate-octopus';
    case 'dino': return 'animate-dino';
    case 'snake': return 'animate-snake';
    case 'lizard': return 'animate-lizard';
    case 'turtle': return 'animate-turtle';
    case 'bug': return 'animate-bug';
    case 'snail': return 'animate-snail';
    case 'owl': return 'animate-owl';
    case 'parrot': return 'animate-parrot';
    case 'penguin': return 'animate-penguin';
    case 'eagle': return 'animate-eagle';
    case 'duck': return 'animate-duck';
    case 'swan': return 'animate-swan';
    case 'horse': return 'animate-horse';
    case 'zebra': return 'animate-zebra';
    case 'giraffe': return 'animate-giraffe';
    case 'elephant': return 'animate-elephant';
    case 'rhino': return 'animate-rhino';
    case 'hippo': return 'animate-hippo';
    case 'camel': return 'animate-camel';
    case 'llama': return 'animate-llama';
    case 'sheep': return 'animate-sheep';
    case 'goat': return 'animate-goat';
    case 'deer': return 'animate-deer';
    case 'sound': return 'animate-sound';
    case 'money': return 'animate-money';
    case 'flicker': return 'animate-flicker';
    case 'ring': return 'animate-ring';
    case 'run': return 'animate-run';
    case 'climb': return 'animate-climb';
    case 'slide': return 'animate-slide';
    case 'swing': return 'animate-swing';
    case 'row': return 'animate-row';
    case 'crawl': return 'animate-crawl';
    case 'smoke': return 'animate-smoke';
    case 'jump': return 'animate-jump';
    case 'slow': return 'animate-slow';
    case 'swim': return 'animate-swim';
    case 'whale': return 'animate-whale';
    case 'dolphin': return 'animate-dolphin';
    case 'croc': return 'animate-croc';
    case 'relax': return 'animate-relax';
    case 'robot': return 'animate-robot';
    case 'wolf': return 'animate-wolf';
    case 'koala': return 'animate-koala';
    case 'gorilla': return 'animate-gorilla';
    case 'orangutan': return 'animate-gorilla';
    case 'raccoon': return 'animate-raccoon';
    case 'peacock': return 'animate-peacock';
    case 'flamingo': return 'animate-flamingo';
    case 'turkey': return 'animate-turkey';
    case 'cricket': return 'animate-cricket';
    case 'ant': return 'animate-ant';
    case 'beetle': return 'animate-beetle';
    case 'mosquito': return 'animate-mosquito';
    case 'cockroach': return 'animate-cockroach';
    case 'coral': return 'animate-coral';
    case 'shell': return 'animate-shell';
    case 'seal': return 'animate-seal';
    default: return 'animate-bounce-hover';
  }
};

const EmojiPicker: React.FC<EmojiPickerProps> = ({ onSelect, onClose }) => {
  const [activeCategory, setActiveCategory] = useState('smile');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredEmojis = useMemo(() => {
    if (!searchQuery.trim()) {
      const category = EMOJI_CATEGORIES.find(c => c.id === activeCategory);
      return category?.emojis || [];
    }
    
    return EMOJI_CATEGORIES.flatMap(category => 
      category.emojis.filter(item => 
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [activeCategory, searchQuery]);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onClose}>
      <div 
        className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <style>{`
          @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-3px); } 75% { transform: translateX(3px); } }
          @keyframes roll { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
          @keyframes sweat { 0%, 100% { opacity: 0.7; } 50% { opacity: 1; transform: scale(1.1); } }
          @keyframes peek { 0%, 100% { transform: scale(1); } 50% { transform: scale(0.9) translateX(5px); } }
          @keyframes halo { 0%, 100% { text-shadow: 0 0 5px #FFD700; } 50% { text-shadow: 0 0 20px #FFD700; } }
          @keyframes heartbeat { 0%, 100% { transform: scale(1); } 25% { transform: scale(1.3); } 50% { transform: scale(1); } 75% { transform: scale(1.2); } }
          @keyframes sparkle { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; text-shadow: 0 0 10px #FFD700; } }
          @keyframes twinkle { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.5; transform: scale(1.2); } }
          @keyframes blow { 0% { transform: translateY(0) rotate(0deg); } 50% { transform: translateY(-10px) rotate(15deg); } 100% { transform: translateY(0) rotate(0deg); } }
          @keyframes yum { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.2) rotate(-5deg); } }
          @keyframes wiggle { 0%, 100% { transform: rotate(0deg); } 25% { transform: rotate(-10deg); } 75% { transform: rotate(10deg); } }
          @keyframes wink { 0%, 100% { transform: scale(1); } 50% { transform: scale(0.8) translateY(2px); } }
          @keyframes tilt { 0%, 100% { transform: rotate(0deg); } 50% { transform: rotate(-15deg); } }
          @keyframes worry { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(3px); } }
          @keyframes frown { 0%, 100% { transform: scale(1); } 50% { transform: scale(0.95) translateY(2px); } }
          @keyframes pop { 0% { transform: scale(0); opacity: 0; } 50% { transform: scale(1.3); } 100% { transform: scale(1); opacity: 1; } }
          @keyframes shock { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.2); } }
          @keyframes crybaby { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(3px); filter: brightness(1.1); } }
          @keyframes tremble { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-2px); } 75% { transform: translateX(2px); } }
          @keyframes cry { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(5px); } }
          @keyframes bawling { 0%, 100% { transform: translateY(0); } 25% { transform: translateY(3px) rotate(-3deg); } 75% { transform: translateY(3px) rotate(3deg); } }
          @keyframes scream { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.3); } }
          @keyframes explode { 0% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.5); opacity: 0.5; } 100% { transform: scale(1); opacity: 1; } }
          @keyframes thumbsup { 0%, 100% { transform: rotate(0deg); } 50% { transform: rotate(15deg); } }
          @keyframes thumbsdown { 0%, 100% { transform: rotate(0deg); } 50% { transform: rotate(-15deg); } }
          @keyframes clap { 0%, 100% { transform: rotate(0deg); } 25% { transform: rotate(10deg); } 75% { transform: rotate(-10deg); } }
          @keyframes raise { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
          @keyframes wave { 0% { transform: rotate(0deg); } 25% { transform: rotate(20deg); } 50% { transform: rotate(0deg); } 75% { transform: rotate(-20deg); } 100% { transform: rotate(0deg); } }
          @keyframes stop { 0%, 100% { transform: scale(1); } }
          @keyframes shakehand { 0%, 100% { transform: translateX(0); } 50% { transform: translateX(5px); } }
          @keyframes flex { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
          @keyframes victory { 0%, 100% { transform: rotate(0deg); } 25% { transform: rotate(15deg); } 75% { transform: rotate(-15deg); } }
          @keyframes rock { 0%, 100% { transform: rotate(0deg); } 25% { transform: rotate(-10deg); } 75% { transform: rotate(10deg); } }
          @keyframes ok { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
          @keyframes pray { 0%, 100% { transform: scale(1); } 50% { transform: scale(0.95); } }
          @keyframes ily { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.2); } }
          @keyframes cross { 0%, 100% { transform: rotate(0deg); } 50% { transform: rotate(10deg); } }
          @keyframes punch { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.2); } }
          @keyframes vulcan { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
          @keyframes money { 0%, 100% { transform: translateY(0) rotate(0deg); } 25% { transform: translateY(-5px) rotate(-5deg); } 75% { transform: translateY(-5px) rotate(5deg); } }
          @keyframes flicker { 0%, 100% { opacity: 1; } 50% { opacity: 0.7; } }
          @keyframes ring { 0%, 100% { transform: rotate(0deg); } 25% { transform: rotate(10deg); } 75% { transform: rotate(-10deg); } }
          @keyframes run { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
          @keyframes climb { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-5px); } }
          @keyframes slide { 0%, 100% { transform: translateX(0); } 50% { transform: translateX(5px); } }
          @keyframes swing { 0%, 100% { transform: rotate(0deg); } 50% { transform: rotate(15deg); } }
          @keyframes row { 0%, 100% { transform: rotate(0deg); } 25% { transform: rotate(10deg); } 75% { transform: rotate(-10deg); } }
          @keyframes crawl { 0%, 100% { transform: translateX(0); } 50% { transform: translateX(3px); } }
          @keyframes smoke { 0%, 100% { opacity: 1; } 50% { opacity: 0.7; transform: scale(1.1); } }
          @keyframes jump { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
          @keyframes slow { 0%, 100% { transform: scale(1); } 50% { transform: scale(0.98); } }
          @keyframes swim { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
          @keyframes whale { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-5px); } }
          @keyframes dolphin { 0%, 100% { transform: translateY(0) rotate(0deg); } 50% { transform: translateY(-10px) rotate(-10deg); } }
          @keyframes croc { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
          @keyframes relax { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.02); } }
          @keyframes robot { 0%, 100% { transform: rotate(0deg); } 25% { transform: rotate(5deg); } 75% { transform: rotate(-5deg); } }
          @keyframes wolf { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
          @keyframes koala { 0%, 100% { transform: scale(1); } 50% { transform: scale(0.95); } }
          @keyframes gorilla { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
          @keyframes raccoon { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
          @keyframes peacock { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
          @keyframes flamingo { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
          @keyframes turkey { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
          @keyframes cricket { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-2px); } }
          @keyframes ant { 0%, 100% { transform: translateX(0); } 50% { transform: translateX(2px); } }
          @keyframes beetle { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
          @keyframes mosquito { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
          @keyframes cockroach { 0%, 100% { transform: translateX(0); } 50% { transform: translateX(3px); } }
          @keyframes coral { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
          @keyframes shell { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
          @keyframes seal { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
          @keyframes bounce-hover { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.1); } }
          
          /* 所有动画都持续运行 */
          .animate-shake { animation: shake 0.5s ease-in-out infinite; }
          .animate-roll { animation: roll 3s linear infinite; }
          .animate-sweat { animation: sweat 1.5s ease-in-out infinite; }
          .animate-peek { animation: peek 2s ease-in-out infinite; }
          .animate-halo { animation: halo 1s ease-in-out infinite; }
          .animate-heartbeat { animation: heartbeat 1.5s ease-in-out infinite; }
          .animate-sparkle { animation: sparkle 2s ease-in-out infinite; }
          .animate-twinkle { animation: twinkle 1.5s ease-in-out infinite; }
          .animate-blow { animation: blow 2s ease-in-out infinite; }
          .animate-yum { animation: yum 1.5s ease-in-out infinite; }
          .animate-wiggle { animation: wiggle 0.5s ease-in-out infinite; }
          .animate-wink { animation: wink 2s ease-in-out infinite; }
          .animate-tilt { animation: tilt 1.5s ease-in-out infinite; }
          .animate-worry { animation: worry 1.5s ease-in-out infinite; }
          .animate-frown { animation: frown 1.5s ease-in-out infinite; }
          .animate-pop { animation: pop 1s ease-in-out infinite; }
          .animate-shock { animation: shock 1s ease-in-out infinite; }
          .animate-crybaby { animation: crybaby 1.5s ease-in-out infinite; }
          .animate-tremble { animation: tremble 0.3s ease-in-out infinite; }
          .animate-cry { animation: cry 1.5s ease-in-out infinite; }
          .animate-bawling { animation: bawling 1s ease-in-out infinite; }
          .animate-scream { animation: scream 1s ease-in-out infinite; }
          .animate-explode { animation: explode 1s ease-in-out infinite; }
          .animate-thumbsup { animation: thumbsup 1s ease-in-out infinite; }
          .animate-thumbsdown { animation: thumbsdown 1s ease-in-out infinite; }
          .animate-clap { animation: clap 0.5s ease-in-out infinite; }
          .animate-raise { animation: raise 1s ease-in-out infinite; }
          .animate-wave { animation: wave 1.5s ease-in-out infinite; }
          .animate-stop { animation: stop 2s ease-in-out infinite; }
          .animate-shakehand { animation: shakehand 0.5s ease-in-out infinite; }
          .animate-flex { animation: flex 1s ease-in-out infinite; }
          .animate-victory { animation: victory 1s ease-in-out infinite; }
          .animate-rock { animation: rock 0.5s ease-in-out infinite; }
          .animate-ok { animation: ok 1.5s ease-in-out infinite; }
          .animate-pray { animation: pray 2s ease-in-out infinite; }
          .animate-ily { animation: ily 1.5s ease-in-out infinite; }
          .animate-cross { animation: cross 1s ease-in-out infinite; }
          .animate-punch { animation: punch 1s ease-in-out infinite; }
          .animate-vulcan { animation: vulcan 1.5s ease-in-out infinite; }
          .animate-money { animation: money 1s ease-in-out infinite; }
          .animate-flicker { animation: flicker 1s ease-in-out infinite; }
          .animate-ring { animation: ring 1s ease-in-out infinite; }
          .animate-run { animation: run 0.3s ease-in-out infinite; }
          .animate-climb { animation: climb 0.5s ease-in-out infinite; }
          .animate-slide { animation: slide 1s ease-in-out infinite; }
          .animate-swing { animation: swing 1s ease-in-out infinite; }
          .animate-row { animation: row 0.8s ease-in-out infinite; }
          .animate-crawl { animation: crawl 0.5s ease-in-out infinite; }
          .animate-smoke { animation: smoke 1.5s ease-in-out infinite; }
          .animate-jump { animation: jump 0.5s ease-in-out infinite; }
          .animate-slow { animation: slow 3s ease-in-out infinite; }
          .animate-swim { animation: swim 0.5s ease-in-out infinite; }
          .animate-whale { animation: whale 1s ease-in-out infinite; }
          .animate-dolphin { animation: dolphin 0.8s ease-in-out infinite; }
          .animate-croc { animation: croc 2s ease-in-out infinite; }
          .animate-relax { animation: relax 3s ease-in-out infinite; }
          .animate-robot { animation: robot 1s ease-in-out infinite; }
          .animate-wolf { animation: wolf 1.5s ease-in-out infinite; }
          .animate-koala { animation: koala 2s ease-in-out infinite; }
          .animate-gorilla { animation: gorilla 1.5s ease-in-out infinite; }
          .animate-raccoon { animation: raccoon 1.5s ease-in-out infinite; }
          .animate-peacock { animation: peacock 1.5s ease-in-out infinite; }
          .animate-flamingo { animation: flamingo 1.5s ease-in-out infinite; }
          .animate-turkey { animation: turkey 1.5s ease-in-out infinite; }
          .animate-cricket { animation: cricket 0.5s ease-in-out infinite; }
          .animate-ant { animation: ant 0.5s ease-in-out infinite; }
          .animate-beetle { animation: beetle 1.5s ease-in-out infinite; }
          .animate-mosquito { animation: mosquito 0.3s ease-in-out infinite; }
          .animate-cockroach { animation: cockroach 0.5s ease-in-out infinite; }
          .animate-coral { animation: coral 1.5s ease-in-out infinite; }
          .animate-shell { animation: shell 1.5s ease-in-out infinite; }
          .animate-seal { animation: seal 0.5s ease-in-out infinite; }
          .animate-bounce-hover { animation: bounce-hover 1s ease-in-out infinite; }
        `}</style>
        <div className="p-3">
          <div className="relative mb-3">
            <input
              type="text"
              placeholder="搜索表情..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery('')}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <X size={18} />
              </button>
            )}
          </div>
          <div className="flex border-b border-gray-200 pb-2 mb-2 overflow-x-auto">
            {EMOJI_CATEGORIES.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-sm transition-all whitespace-nowrap ${
                  activeCategory === category.id
                    ? 'bg-blue-500 text-white'
                    : 'hover:bg-gray-100 text-gray-700'
                }`}
              >
                <span className="text-lg">{category.icon}</span>
                <span>{category.name}</span>
              </button>
            ))}
          </div>
          <div className="max-h-80 overflow-y-auto">
            <div className="grid grid-cols-8 gap-1">
              {filteredEmojis.map((item, index) => (
                <button
                  key={index}
                  onClick={() => {
                    onSelect(item.emoji);
                    onClose();
                  }}
                  className={`text-2xl p-1 rounded-lg hover:bg-gray-100 transition-all duration-200 ${getAnimationClass(item.animation)}`}
                  title={item.name}
                >
                  {item.emoji}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmojiPicker;